"use client";
import { useSearchParams } from "next/navigation";
import dynamic from "next/dynamic";
import Link from "next/link";
import { ValuationFlow } from "@/components/valuation/valuation-flow";
import type { ValuationToolProps } from "./legacy-valuation-tool";

const LegacyValuationTool = dynamic(() =>
  import("./legacy-valuation-tool").then(
    (module) => module.LegacyValuationTool,
  ),
);
export type { ValuationToolProps } from "./legacy-valuation-tool";
export function ValuationTool({
  placement = "body",
  ...props
}: ValuationToolProps & { placement?: "hero" | "body" }) {
  const params = useSearchParams();
  if (
    process.env.NEXT_PUBLIC_VALUATION_LEADS_ENABLED !== "true" ||
    params.has("vid")
  ) {
    if (placement === "hero")
      return (
        <Link
          href="#valuation-tool-form"
          className="inline-flex h-11 items-center rounded-lg bg-foreground px-5 text-sm font-semibold text-background transition-colors hover:bg-foreground/90"
        >
          Start free valuation
        </Link>
      );
    return <LegacyValuationTool {...props} />;
  }
  if (placement === "body") return null;
  return (
    <ValuationFlow industry={props.businessType} region={props.state?.name} />
  );
}
